import styles from './headerMenu.module.css';
import OrderActions from './orderActions';
import {useMenuStore} from '../../store/menuStore';
import {Button, Icons} from '@toppy-webshop/toppy-design-system';

interface HeaderMenuProps {
    menuTitle: string;
}

const HeaderMenu = (props: HeaderMenuProps) => {
    const menu = useMenuStore(state => state);
    return (
        <div className={styles.menu}>
            <div className={styles['menu-button']} onClick={menu.toggleMenu}>
                <Button
                    label={props.menuTitle}
                    rightIcon={Icons.HAMBURGER}
                    size={'s'}
                />
            </div>

            {menu.isMenuOpen && [
                <div
                    className={styles['popup-menu-backdrop']}
                    onClick={menu.toggleMenu}
                    key={'1'}
                ></div>,
                <div className={styles['menu-container']} key={'2'}>
                    <div className={styles['popup-menu']}>
                        <OrderActions isMobilePopup={true} />
                    </div>
                </div>,
            ]}
        </div>
    );
};

export default HeaderMenu;
